<div id="status-afip-container">
  <p class="heading-02-semi-bold">
    Lo sentimos, los servicios de la AFIP no están disponibles en este momento.
    <br />
    Le sugerimos que intente acceder más tarde o consulte en la página web de la
    misma para obtener información actualizada sobre el estado del servicio.
    Disculpe las molestias.
  </p>
</div>
